module.exports = __webpack_public_path__ + "img/detail1.637fc380.png";